module.exports = __webpack_public_path__ + "img/kachel-einzelneprodukte_ALOEVERADRINKINGGEL.1e004d8c.png";